
import {FC, useCallback, useEffect, useMemo, useState} from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { HseContextSelector } from 'shared/reducers/hseCurrentContext';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../core";

export enum SCROLL_POSITION {
  start = 'start',
  center = 'center',
  end = 'end'
}

export const useScrollByAnchorElement = (scrollPosition?: SCROLL_POSITION, canScrollOnAnyBlock?: boolean) => {
    const location = useLocation();
    const { anchorLinks } = useSelector(HseContextSelector);
    const [time, setTime] = useState(Date.now());
    const [scrollElement, setScrollElement] = useState<Element | null>(null);

    const getElement = useCallback((postId: string, maxAttempts = 3, attemptInterval = 1000) => {
        const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`);
        if (!element && maxAttempts > 1) {
            setTimeout(() => getElement(postId, maxAttempts - 1, attemptInterval), attemptInterval);
        } else {
            setTime(Date.now());
            setScrollElement(element);
        }
    }, []);

    useEffect(() => {

        if (location.hash !== '') {
            const id = location.hash.replace('#', '');

            if (canScrollOnAnyBlock) {
                getElement(id)
            }

            const [anchor] = anchorLinks?.filter((anchor) => anchor?.postId === id);
            if (anchor) {
                getElement(anchor?.postId)
            }
        }

    }, [location, anchorLinks, canScrollOnAnyBlock, getElement])

    useEffect(() => {
        if (!!scrollElement) {
          setTimeout(() => {

              if (scrollPosition === SCROLL_POSITION.start) {
                  const yOffset = -70;
                  const y = scrollElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                  window.scrollTo({top: y, behavior: 'smooth'});
                  return;
              }

            scrollElement.scrollIntoView({ behavior: "smooth", block: scrollPosition || "center", inline: scrollPosition || "start"});
          }, 1500)
        }
      }, [scrollElement, time, scrollPosition]);

      return [];
}
import {FC, useCallback, useEffect, useMemo, useState} from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { HseContextSelector } from 'shared/reducers/hseCurrentContext';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../core";

export enum SCROLL_POSITION {
  start = 'start',
  center = 'center',
  end = 'end'
}

export const useScrollByAnchorElement = (scrollPosition?: SCROLL_POSITION, canScrollOnAnyBlock?: boolean) => {
    const location = useLocation();
    const { anchorLinks } = useSelector(HseContextSelector);
    const [time, setTime] = useState(Date.now());
    const [scrollElement, setScrollElement] = useState<Element | null>(null);

    const getElement = useCallback((postId: string, maxAttempts = 3, attemptInterval = 1000) => {
        const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`);
        if (!element && maxAttempts > 1) {
            setTimeout(() => getElement(postId, maxAttempts - 1, attemptInterval), attemptInterval);
        } else {
            setTime(Date.now());
            setScrollElement(element);
        }
    }, []);

    useEffect(() => {

        if (location.hash !== '') {
            const id = location.hash.replace('#', '');

            if (canScrollOnAnyBlock) {
                getElement(id)
            }

            const [anchor] = anchorLinks?.filter((anchor) => anchor?.postId === id);
            if (anchor) {
                getElement(anchor?.postId)
            }
        }

    }, [location, anchorLinks, canScrollOnAnyBlock, getElement])

    useEffect(() => {
        if (!!scrollElement) {
          setTimeout(() => {

              if (scrollPosition === SCROLL_POSITION.start) {
                  const yOffset = -70;
                  const y = scrollElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
                  window.scrollTo({top: y, behavior: 'smooth'});
                  return;
              }

            scrollElement.scrollIntoView({ behavior: "smooth", block: scrollPosition || "center", inline: scrollPosition || "start"});
          }, 1500)
        }
      }, [scrollElement, time, scrollPosition]);

      return [];
}